export default __webpack_public_path__ + "static/media/l_wdt_c_1.52815d9d.mp3";